// ABOUTME: The one place the feed module picks its API: pro-core's (./api), or the mock layer's in a dev build that
// ABOUTME: names this module in VITE_MOCK_API. The query calls through here and never knows which it is.
import { mockRegistry } from 'mocks/registry';
import * as api from './api';

export const feedApi: typeof api = mockRegistry.apis.feed ?? api;
